/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Seven_SeasInputs */

const bn_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাত সমুদ্র (উন্মুক্ত মহাসাগর)`)
};

const de_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieben Meere (offener Ozean)`)
};

const el_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επτά θάλασσες (ανοιχτός ωκεανός)`)
};

const en_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seven seas (open ocean)`)
};

const es_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siete mares (océano abierto)`)
};

const fr_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sept mers (océan ouvert)`)
};

const hi_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सात समुद्र (खुला महासागर)`)
};

const hu_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hét tenger (nyílt óceán)`)
};

const id_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuh lautan (lautan terbuka)`)
};

const it_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sette mari (oceano aperto)`)
};

const ja_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`七つの海（外洋）`)
};

const ko_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일곱 개의 바다(넓은 바다)`)
};

const nl_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeven zeeën (open oceaan)`)
};

const pl_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siedem mórz (otwarty ocean)`)
};

const pt_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sete mares (mar aberto)`)
};

const ru_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семь морей (открытый океан)`)
};

const sv_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sju hav (öppet hav)`)
};

const tr_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yedi deniz (açık okyanus)`)
};

const uk_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сім морів (відкритий океан)`)
};

const vi_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảy biển (biển mở)`)
};

const zh_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`七大洋（公海）`)
};

const zh_hant_geo_label_seven_seas = /** @type {(inputs: Geo_Label_Seven_SeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`七大洋（公海）`)
};

/**
* | output |
* | --- |
* | "Seven seas (open ocean)" |
*
* @param {Geo_Label_Seven_SeasInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_seven_seas = /** @type {((inputs?: Geo_Label_Seven_SeasInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Seven_SeasInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_seven_seas(inputs)
	if (locale === "de") return de_geo_label_seven_seas(inputs)
	if (locale === "el") return el_geo_label_seven_seas(inputs)
	if (locale === "en") return en_geo_label_seven_seas(inputs)
	if (locale === "es") return es_geo_label_seven_seas(inputs)
	if (locale === "fr") return fr_geo_label_seven_seas(inputs)
	if (locale === "hi") return hi_geo_label_seven_seas(inputs)
	if (locale === "hu") return hu_geo_label_seven_seas(inputs)
	if (locale === "id") return id_geo_label_seven_seas(inputs)
	if (locale === "it") return it_geo_label_seven_seas(inputs)
	if (locale === "ja") return ja_geo_label_seven_seas(inputs)
	if (locale === "ko") return ko_geo_label_seven_seas(inputs)
	if (locale === "nl") return nl_geo_label_seven_seas(inputs)
	if (locale === "pl") return pl_geo_label_seven_seas(inputs)
	if (locale === "pt") return pt_geo_label_seven_seas(inputs)
	if (locale === "ru") return ru_geo_label_seven_seas(inputs)
	if (locale === "sv") return sv_geo_label_seven_seas(inputs)
	if (locale === "tr") return tr_geo_label_seven_seas(inputs)
	if (locale === "uk") return uk_geo_label_seven_seas(inputs)
	if (locale === "vi") return vi_geo_label_seven_seas(inputs)
	if (locale === "zh") return zh_geo_label_seven_seas(inputs)
	return zh_hant_geo_label_seven_seas(inputs)
});